import React from "react"
import PropTypes from "prop-types"
import Games from './Games'
import PixelConfiguration from './PixelConfiguration'

class GamesIndex extends React.Component {
  render () {
    const {
      games,
      invitations,
      error,
      userId,
      privateToken,
      canImpersonate
    } = this.props

    return (
      <div>
        <Games
          games={games}
          invitations={invitations}
          error={error}
          canImpersonate={canImpersonate}
        />
        <PixelConfiguration userId={userId} privateToken={privateToken} />
      </div>
    )
  }
}

GamesIndex.propTypes = {
  games: PropTypes.array,
  invitations: PropTypes.array,
  error: PropTypes.string,
  userId: PropTypes.number.isRequired,
  privateToken: PropTypes.string.isRequired,
  canImpersonate: PropTypes.bool
}

export default GamesIndex